import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
export function HeroSection() {
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-[#eef6ff] pb-5" data-id="element-124">
      {/* Urgency Bar */}
      <div className="bg-orange-600 text-white text-center py-2 px-4 font-bold text-sm md:text-base flex items-center justify-center gap-2" data-id="element-125">
        <span data-id="element-126">🔥Oferta por tiempo limitado</span>
        <CountdownTimer className="bg-white text-orange-600 px-2 py-0.5 rounded text-sm" data-id="element-127" />
      </div>

      <div className="max-w-4xl mx-auto px-4 pt-4 md:pt-6 text-center" data-id="element-128">
        <h1 className="text-[1.575rem] md:text-[1.97rem] lg:text-[2.365rem] font-extrabold text-gray-900 leading-snug mb-4 max-w-2xl mx-auto" data-id="element-129">
          Kit de actividades listas para usar que{' '}
          <span className="text-blue-600" data-id="element-130">
            impulsan el desarrollo de tu hijo
          </span>{' '}
          🧒
        </h1>
        <span className="inline-block bg-blue-600/10 text-blue-700 font-semibold text-sm md:text-base px-4 py-1 rounded-full mb-4 border border-blue-200/50" data-id="element-131">
          de 1 a 3 años
        </span>

        <div className="relative max-w-[17rem] md:max-w-[25rem] mx-auto mb-3 cursor-pointer group" onClick={scrollToCompra} data-id="element-132">
          <img src="https://cdn.magicpatterns.com/uploads/78DksSvkYN6mJcEMEkBaJa/Diseno_sin_titulo_(17).png" alt="Kit de Actividades para la Inteligencia" className="w-full h-auto drop-shadow-2xl transition-transform duration-300 group-hover:scale-105" data-id="element-133" />
          <div className="absolute inset-0 bg-black/0 group-hover:bg-black/5 transition-colors rounded-xl flex items-center justify-center" data-id="element-134">
            <span className="bg-white/90 text-gray-900 font-bold px-4 py-2 rounded-full opacity-0 group-hover:opacity-100 transition-opacity shadow-lg" data-id="element-135">
              Ver Oferta
            </span>
          </div>
        </div>

        <h2 className="text-base md:text-lg font-bold text-gray-700 mb-3 max-w-2xl mx-auto leading-relaxed" data-id="element-136">
          Más de 300 actividades para imprimir y usar en casa, sin pantallas y
          sin preparación… para que tu hijo aprenda jugando.
        </h2>

        <div className="bg-amber-50/60 border border-amber-100 rounded-xl p-3 mb-3 max-w-md mx-auto text-left shadow-sm" data-id="element-137">
          <ul className="space-y-2" data-id="element-138">
            <li className="flex items-center text-sm md:text-base font-medium text-gray-800" data-id="element-139">
              <CheckIcon className="w-5 h-5 text-green-500 mr-2 flex-shrink-0" data-id="element-140" />
              6 Libros de actividades completos
            </li>
            <li className="flex items-center text-sm md:text-base font-medium text-gray-800" data-id="element-141">
              <CheckIcon className="w-5 h-5 text-green-500 mr-2 flex-shrink-0" data-id="element-142" />
              <span className="bg-amber-100 px-1.5 py-0.5 rounded text-sm" data-id="element-143">
                3 Bonos exclusivos GRATIS
              </span>
            </li>
            <li className="flex items-center text-sm md:text-base font-medium text-gray-800" data-id="element-144">
              <CheckIcon className="w-5 h-5 text-green-500 mr-2 flex-shrink-0" data-id="element-145" />
              Material listo para imprimir en PDF
            </li>
          </ul>
        </div>

        <div className="max-w-md mx-auto space-y-3 mb-4" data-id="element-146">
          {/* Bloque de resultados */}
          <div className="bg-white border border-gray-100 rounded-xl p-3 shadow-sm text-center" data-id="element-147">
            <p className="text-sm font-semibold text-gray-900 mb-0.5" data-id="element-148">
              ✨ Resultados visibles en pocas semanas
            </p>
            <p className="text-xs text-gray-500" data-id="element-149">
              Avances en su concentración, lenguaje y motricidad.
            </p>
          </div>

          {/* Bloque de autoridad */}
          <div className="bg-white border border-gray-100 rounded-xl p-3 shadow-sm text-center" data-id="element-150">
            <p className="text-sm font-semibold text-gray-900 mb-0.5" data-id="element-151">
              📖 Material diseñado por especialistas en desarrollo infantil
            </p>
            <p className="text-xs text-gray-500" data-id="element-152">
              Pensado para padres que quieren enseñar sin estrés ni
              complicaciones.
            </p>
          </div>

          {/* Bloque de prueba social */}
          <div className="bg-gray-800 rounded-xl p-2.5 text-center" data-id="element-153">
            <p className="text-white font-medium text-xs" data-id="element-154">
              🔥 +3000 mamás y papás ya lo usan con sus hijos
            </p>
          </div>
        </div>

        <div className="max-w-md mx-auto" data-id="element-155">
          <button onClick={scrollToCompra} className="w-full bg-orange-500 hover:bg-orange-600 text-white text-lg md:text-xl font-bold py-4 px-8 rounded-full shadow-[0_4px_14px_0_rgba(249,115,22,0.39)] transition-all duration-200 uppercase btn-pulse" data-id="element-156">
            👇 ACCEDER AL KIT AHORA
          </button>
        </div>
      </div>
    </section>;
}